import React from 'react';

const Profile = () => {
  console.log('Profile');
  return (
    <div>Profile</div>
  );
};

export default Profile;
